import apolloClient from 'store/apolloClient';
import apiCall from 'shared/utils/apiCall';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';

import { getCurrentLanguage } from 'modules/language/selectors/language';

import createAction from './';
import * as services from '../services/organizationDetails';

export const FETCH_TERMS_AND_CONDITIONS = createAsyncAction(createAction('FETCH_TERMS_AND_CONDITIONS'));

export const fetchTermsAndConditions = () => (dispatch, getState) => {
  dispatch({ type: FETCH_TERMS_AND_CONDITIONS.pending });

  const state = getState();
  const { selectedOrganizationToken: orgId } = state.auth.organizations;
  const locale = getCurrentLanguage();

  const apiCallParams = {
    query: services.FETCH_TERMS_AND_CONDITIONS,
    variables: {
      orgId,
      locale: locale.toUpperCase(),
    },
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(({ data: { organizationDetails: { config } } }) =>
      dispatch({
        type: FETCH_TERMS_AND_CONDITIONS.success,
        payload: { content: config.termsAndConditions },
      }))
    .catch((err) => {
      dispatch(errorAction(FETCH_TERMS_AND_CONDITIONS.failure, err));
      throw err;
    });
};

